module.exports = __webpack_public_path__ + "logo.daa97bb1.png";